// extracted by mini-css-extract-plugin
export var root = "ResponsiveTable-module--root--08402";
export var table = "ResponsiveTable-module--table--e9acb";